import { CommunityPostPage } from '@/components/postPages/PostPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(CommunityPostPage, {
  requiresEvery: [RouteRestrictions.COMMUNITY_ACCESS],
});
